// extracted by mini-css-extract-plugin
module.exports = {"category":"Category-module--category--gmM9o","letter":"Category-module--letter--2El0i","items":"Category-module--items--3m_y4","item":"Category-module--item--12Nxs"};